import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';
import {
  defaultHiredInsuranceStatusProps,
  type ContractedService,
} from '~/domain/Assegurou/contractedServices';
import { formatDate } from '~/utils/date';

export interface InsuranceStatusProps {
  data: ContractedService;
}

const InsuranceStatus: React.FC<InsuranceStatusProps> = ({ data }) => {
  const statusProps =
    defaultHiredInsuranceStatusProps[
      data.cancellationDate ? 'canceled' : data.status ?? 'approved'
    ];

  return (
    <View className="flex-row items-center justify-between">
      <View className={`px-2 rounded-[100px] ${statusProps.bgColor}`}>
        <Text className="text-light-100 text-xs">{statusProps.label}</Text>
      </View>

      <Text className="text-gray-400 text-sm flex-1 text-right">
        {data.cancellationDate
          ? `Cancelado em: ${formatDate(data.cancellationDate)}`
          : `Adesão em: ${formatDate(data.saleDate)}`}
      </Text>
    </View>
  );
};

export default InsuranceStatus;
